export const EntityRole = {
  ACCOUNT: "ACCOUNT",
  BENCHMARK: "BENCHMARK",
};
